import { Effect, Layer } from 'effect';
import { GavelConfig } from '../gavelConfig';
import { HttpService } from '../http';
import { Product as ProductService } from '@fixtuur/gift-client';
import { GetModularOptions, GetModularTemplate, ListModularTemplates } from './gavel/requests';
import { GetModularOptionsResolver, GetModularTemplateResolver, ListModularTemplatesResolver, } from './gavel/resolvers';
import { ModularTemplateService } from './service';
export const GavelModularTemplateService = Layer.effect(ModularTemplateService, Effect.gen(function* () {
    const http = yield* HttpService;
    const productService = yield* ProductService.ProductService;
    const gavelConfig = yield* GavelConfig;
    const gavelUrl = gavelConfig.gavelUrl;
    const modularTemplateResolver = GetModularTemplateResolver(http, gavelUrl);
    const getModularTemplateById = (tenant, id) => Effect.request(GetModularTemplate({ tenant, id }), modularTemplateResolver);
    const modularOptionsResolver = GetModularOptionsResolver(getModularTemplateById, productService);
    const getModularOptionsById = (tenant, id) => Effect.request(GetModularOptions({ tenant, id }), modularOptionsResolver);
    const listModularTemplatesResolver = ListModularTemplatesResolver(http, gavelUrl);
    const listModularTemplates = (tenant) => Effect.request(ListModularTemplates({ tenant }), listModularTemplatesResolver);
    return { getModularTemplateById, getModularOptionsById, listModularTemplates };
}));
